import { render, staticRenderFns } from "./OptionallyRestrict.vue?vue&type=template&id=290db99c&"
import script from "./OptionallyRestrict.vue?vue&type=script&lang=js&"
export * from "./OptionallyRestrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports